(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (root) {
    root.LiljaDispatch = api;
  }
  if (typeof HTMLElement !== 'undefined' && typeof customElements !== 'undefined') {
    api.defineCustomElement();
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var TZ_DEFAULT = 'Europe/Copenhagen';
  var WEEKDAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var DEFAULT_CLOSED_DATES = [
    '01-01',
    '12-24',
    '12-25',
    '12-26',
    '2026-04-02',
    '2026-04-03',
    '2026-04-06',
    '2026-05-14',
    '2026-05-25',
    '2027-03-25',
    '2027-03-26',
    '2027-03-29',
    '2027-05-06',
    '2027-05-17',
    '2028-04-13',
    '2028-04-14',
    '2028-04-17',
    '2028-05-25',
    '2028-06-05',
  ];
  var DEFAULT_CONFIG = {
    paused: false,
    packDays: [1, 2, 3, 4, 5],
    cutoffHour: 23,
    cutoffMinute: 59,
    closedDates: DEFAULT_CLOSED_DATES.slice(),
    countdownThresholdHours: 12,
    timeZone: TZ_DEFAULT,
    dispatchHour: 7,
    dispatchMinute: 0,
  };
  var shownPlacements = typeof WeakSet === 'function' ? null : {};
  if (typeof window !== 'undefined') {
    window.__liljaDispatchShown = window.__liljaDispatchShown || {};
    shownPlacements = window.__liljaDispatchShown;
  }

  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function parts(date, timeZone) {
    var map = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(date)
      .forEach(function (part) {
        if (part.type !== 'literal') map[part.type] = part.value;
      });
    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute),
      second: Number(map.second),
    };
  }

  function tzOffsetMs(date, timeZone) {
    var p = parts(date, timeZone);
    var asUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    return asUtc - date.getTime();
  }

  function zonedMs(year, month, day, hour, minute, timeZone) {
    var guess = Date.UTC(year, month - 1, day, hour, minute, 0);
    var first = new Date(guess - tzOffsetMs(new Date(guess), timeZone));
    return guess - tzOffsetMs(first, timeZone);
  }

  function zonedDate(year, month, day, hour, minute, timeZone) {
    return new Date(zonedMs(year, month, day, hour, minute, timeZone));
  }

  function addDays(year, month, day, count) {
    var dt = new Date(Date.UTC(year, month - 1, day + count));
    return {
      year: dt.getUTCFullYear(),
      month: dt.getUTCMonth() + 1,
      day: dt.getUTCDate(),
    };
  }

  function weekday(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  }

  function ymd(year, month, day) {
    return year + '-' + pad2(month) + '-' + pad2(day);
  }

  function md(month, day) {
    return pad2(month) + '-' + pad2(day);
  }

  function parseClosedDates(value) {
    if (Array.isArray(value)) {
      return value
        .map(function (item) {
          return String(item).trim();
        })
        .filter(Boolean);
    }
    return String(value || '')
      .split(/[\n\r,]+/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function parseCutoff(value) {
    var match = String(value || '23:59').match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return { hour: 23, minute: 59 };
    return {
      hour: Math.min(23, Math.max(0, Number(match[1]))),
      minute: Math.min(59, Math.max(0, Number(match[2]))),
    };
  }

  function parsePackDays(value) {
    if (Array.isArray(value)) {
      return value.map(Number).filter(function (day) {
        return day >= 0 && day <= 6;
      });
    }
    return String(value || '1,2,3,4,5')
      .split(',')
      .map(function (item) {
        return Number(item.trim());
      })
      .filter(function (day) {
        return day >= 0 && day <= 6;
      });
  }

  function isClosed(year, month, day, closedDates) {
    var full = ymd(year, month, day);
    var recurring = md(month, day);
    for (var i = 0; i < closedDates.length; i += 1) {
      if (closedDates[i] === full || closedDates[i] === recurring) return true;
    }
    return false;
  }

  function normalizeConfig(config) {
    var source = config || {};
    var cutoff = parseCutoff(
      source.cutoffTime ||
        (source.cutoffHour != null
          ? pad2(source.cutoffHour) + ':' + pad2(source.cutoffMinute == null ? 0 : source.cutoffMinute)
          : '23:59')
    );
    var packDays = parsePackDays(source.packDays != null ? source.packDays : DEFAULT_CONFIG.packDays);
    var closedDates = parseClosedDates(
      source.closedDates != null ? source.closedDates : DEFAULT_CONFIG.closedDates
    );
    var threshold = Number(source.countdownThresholdHours);
    if (!isFinite(threshold) || threshold <= 0) threshold = DEFAULT_CONFIG.countdownThresholdHours;
    return {
      paused: Boolean(source.paused),
      packDays: packDays,
      cutoffHour: cutoff.hour,
      cutoffMinute: cutoff.minute,
      closedDates: closedDates,
      countdownThresholdHours: threshold,
      timeZone: source.timeZone || TZ_DEFAULT,
      dispatchHour: source.dispatchHour == null ? 7 : Number(source.dispatchHour),
      dispatchMinute: source.dispatchMinute == null ? 0 : Number(source.dispatchMinute),
    };
  }

  function hiddenResult() {
    return {
      cutoffAt: null,
      dispatchAt: null,
      msRemaining: 0,
      state: 'hidden',
    };
  }

  function nextDispatch(now, config) {
    var cfg = normalizeConfig(config);
    if (cfg.paused) return hiddenResult();

    var timeZone = cfg.timeZone;
    var nowParts = parts(now, timeZone);
    var packLookup = {};
    cfg.packDays.forEach(function (day) {
      packLookup[day] = true;
    });

    for (var i = 0; i < 28; i += 1) {
      var candidate = addDays(nowParts.year, nowParts.month, nowParts.day, i);
      var dayNum = weekday(candidate.year, candidate.month, candidate.day);
      if (!packLookup[dayNum]) continue;
      if (isClosed(candidate.year, candidate.month, candidate.day, cfg.closedDates)) continue;

      var previous = addDays(candidate.year, candidate.month, candidate.day, -1);
      var cutoffAt = zonedDate(
        previous.year,
        previous.month,
        previous.day,
        cfg.cutoffHour,
        cfg.cutoffMinute,
        timeZone
      );
      if (cutoffAt.getTime() <= now.getTime()) continue;

      var dispatchAt = zonedDate(
        candidate.year,
        candidate.month,
        candidate.day,
        cfg.dispatchHour,
        cfg.dispatchMinute,
        timeZone
      );
      var msRemaining = cutoffAt.getTime() - now.getTime();
      var thresholdMs = cfg.countdownThresholdHours * 3600000;
      return {
        cutoffAt: cutoffAt,
        dispatchAt: dispatchAt,
        msRemaining: msRemaining,
        state: msRemaining < thresholdMs ? 'countdown' : 'static',
      };
    }

    return hiddenResult();
  }

  function remainingMs(cutoffAt, clientNowMs, offsetMs) {
    return cutoffAt.getTime() - (clientNowMs + offsetMs);
  }

  function isTomorrow(now, dispatchAt, timeZone) {
    var nowParts = parts(now, timeZone);
    var dispatchParts = parts(dispatchAt, timeZone);
    var tomorrow = addDays(nowParts.year, nowParts.month, nowParts.day, 1);
    return (
      tomorrow.year === dispatchParts.year &&
      tomorrow.month === dispatchParts.month &&
      tomorrow.day === dispatchParts.day
    );
  }

  function weekdayKey(dispatchAt, timeZone) {
    var p = parts(dispatchAt, timeZone);
    return WEEKDAY_KEYS[weekday(p.year, p.month, p.day)];
  }

  function countLabel(n, one, many) {
    if (n === 1) return one;
    return n + ' ' + many;
  }

  function formatDuration(ms, dict) {
    var totalMin = Math.max(0, Math.floor(ms / 60000));
    if (totalMin < 1) return dict.underMinute;
    var hours = Math.floor(totalMin / 60);
    var minutes = totalMin % 60;
    if (hours === 0) return countLabel(minutes, dict.minOne, dict.minMany);
    var hourPart = countLabel(hours, dict.hourOne, dict.hourMany);
    if (minutes === 0) return hourPart;
    return hourPart + ' ' + dict.and + ' ' + countLabel(minutes, dict.minOne, dict.minMany);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function applyTemplate(template, replacements) {
    var out = template || '';
    Object.keys(replacements).forEach(function (key) {
      out = out.split(key).join(replacements[key]);
    });
    return out;
  }

  function formatPrimary(result, now, dict) {
    if (!result || result.state === 'hidden' || !result.dispatchAt) {
      return dict.paused;
    }
    var tomorrow = isTomorrow(now, result.dispatchAt, dict.timeZone || TZ_DEFAULT);
    if (result.state === 'countdown') {
      var duration = formatDuration(result.msRemaining, dict);
      if (tomorrow) {
        return applyTemplate(dict.countdownTomorrow, { __DURATION__: duration });
      }
      return applyTemplate(dict.countdownWeekday, {
        __DURATION__: duration,
        __WEEKDAY__: dict.weekdays[weekdayKey(result.dispatchAt, dict.timeZone || TZ_DEFAULT)],
      });
    }
    if (tomorrow) return dict.staticTomorrow;
    return applyTemplate(dict.staticWeekday, {
      __WEEKDAY__: dict.weekdays[weekdayKey(result.dispatchAt, dict.timeZone || TZ_DEFAULT)],
    });
  }

  function formatPrimaryHtml(result, now, dict) {
    if (!result || result.state === 'hidden' || !result.dispatchAt) {
      return escapeHtml(dict.paused);
    }
    var tomorrow = isTomorrow(now, result.dispatchAt, dict.timeZone || TZ_DEFAULT);
    if (result.state === 'countdown') {
      var duration = formatDuration(result.msRemaining, dict);
      var durationHtml = '<span class="lilja-dispatch__duration">' + escapeHtml(duration) + '</span>';
      if (tomorrow) {
        return applyTemplate(dict.countdownTomorrow, { __DURATION__: durationHtml });
      }
      var weekdayHtml =
        '<span class="lilja-dispatch__when">' +
        escapeHtml(dict.weekdays[weekdayKey(result.dispatchAt, dict.timeZone || TZ_DEFAULT)]) +
        '</span>';
      return applyTemplate(dict.countdownWeekday, {
        __DURATION__: durationHtml,
        __WEEKDAY__: weekdayHtml,
      });
    }
    if (tomorrow) return escapeHtml(dict.staticTomorrow);
    return applyTemplate(dict.staticWeekday, {
      __WEEKDAY__:
        '<span class="lilja-dispatch__when">' +
        escapeHtml(dict.weekdays[weekdayKey(result.dispatchAt, dict.timeZone || TZ_DEFAULT)]) +
        '</span>',
    });
  }

  function configFromDataset(dataset) {
    return normalizeConfig({
      paused: dataset.paused === 'true',
      packDays: dataset.packDays,
      cutoffTime: dataset.cutoff,
      closedDates: dataset.closedDates,
      countdownThresholdHours: dataset.threshold,
      timeZone: dataset.timezone || TZ_DEFAULT,
    });
  }

  function dictFromDataset(dataset) {
    return {
      timeZone: dataset.timezone || TZ_DEFAULT,
      minOne: dataset.minOne,
      minMany: dataset.minMany,
      hourOne: dataset.hourOne,
      hourMany: dataset.hourMany,
      and: dataset.and,
      underMinute: dataset.underMinute,
      countdownTomorrow: dataset.copyCountdownTomorrow,
      countdownWeekday: dataset.copyCountdownWeekday,
      staticTomorrow: dataset.copyStaticTomorrow,
      staticWeekday: dataset.copyStaticWeekday,
      paused: dataset.copyPaused,
      weekdays: {
        sunday: dataset.weekdaySunday,
        monday: dataset.weekdayMonday,
        tuesday: dataset.weekdayTuesday,
        wednesday: dataset.weekdayWednesday,
        thursday: dataset.weekdayThursday,
        friday: dataset.weekdayFriday,
        saturday: dataset.weekdaySaturday,
      },
    };
  }

  function captureShown(result, placement, timeZone) {
    if (typeof window === 'undefined' || typeof window.liljaCapture !== 'function') return;
    if (!placement) return;
    if (shownPlacements[placement]) return;
    shownPlacements[placement] = true;
    var weekdayName = result && result.dispatchAt ? weekdayKey(result.dispatchAt, timeZone) : '';
    window.liljaCapture('dispatch_promise_shown', {
      state: result ? result.state : 'hidden',
      hours_to_cutoff: result && result.cutoffAt ? Number((result.msRemaining / 3600000).toFixed(2)) : 0,
      dispatch_weekday: weekdayName,
      placement: placement,
    });
  }

  function defineCustomElement() {
    if (customElements.get('lilja-dispatch')) return;

    class LiljaDispatchEl extends HTMLElement {
      connectedCallback() {
        this.timeZone = this.dataset.timezone || TZ_DEFAULT;
        this.placement = this.dataset.placement || 'pdp';
        this.serverNowMs = Number(this.dataset.serverNow) * 1000;
        if (!isFinite(this.serverNowMs)) this.serverNowMs = Date.now();
        this.offset = this.serverNowMs - Date.now();
        this.config = configFromDataset(this.dataset);
        this.dict = dictFromDataset(this.dataset);
        this.textEl =
          this.querySelector('.lilja-dispatch__line') || this.querySelector('.lilja-dispatch__text');
        this.onVis = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.onVis, 1000);
        document.addEventListener('visibilitychange', this.onVis);
        this.maybeCapture();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVis);
        if (this.drawerObserver) this.drawerObserver.disconnect();
      }

      correctedNow() {
        return new Date(Date.now() + this.offset);
      }

      tick() {
        var now = this.correctedNow();
        var result = nextDispatch(now, this.config);
        if (result.state === 'countdown' && result.msRemaining <= 0) {
          result = nextDispatch(now, this.config);
        }
        if (result.state === 'countdown' && result.cutoffAt) {
          result = Object.assign({}, result, {
            msRemaining: Math.max(0, remainingMs(result.cutoffAt, Date.now(), this.offset)),
          });
          if (result.msRemaining <= 0) {
            now = this.correctedNow();
            result = nextDispatch(now, this.config);
          }
        }
        var html = formatPrimaryHtml(result, now, this.dict);
        if (html === this.lastHtml || !this.textEl) return;
        this.lastHtml = html;
        this.textEl.innerHTML = html;
      }

      maybeCapture() {
        var drawer = this.closest('cart-drawer');
        if (drawer && !drawer.classList.contains('active')) {
          var self = this;
          this.drawerObserver = new MutationObserver(function () {
            if (drawer.classList.contains('active')) {
              self.fireCapture();
              self.drawerObserver.disconnect();
            }
          });
          this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
          return;
        }
        this.fireCapture();
      }

      fireCapture() {
        var now = this.correctedNow();
        captureShown(nextDispatch(now, this.config), this.placement, this.timeZone);
      }
    }

    customElements.define('lilja-dispatch', LiljaDispatchEl);
  }

  return {
    TZ_DEFAULT: TZ_DEFAULT,
    DEFAULT_CONFIG: DEFAULT_CONFIG,
    DEFAULT_CLOSED_DATES: DEFAULT_CLOSED_DATES,
    nextDispatch: nextDispatch,
    remainingMs: remainingMs,
    formatDuration: formatDuration,
    formatPrimary: formatPrimary,
    zonedMs: zonedMs,
    zonedDate: zonedDate,
    parts: parts,
    isTomorrow: isTomorrow,
    weekdayKey: weekdayKey,
    normalizeConfig: normalizeConfig,
    defineCustomElement: defineCustomElement,
  };
});
